const NS = "xtreamflix";

export const userKey = (creds) => `${creds?.server || ""}|${creds?.username || ""}`;

const read = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};
const write = (key, val) => {
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch {
    /* ignore quota */
  }
};

/* ---------------- Favourites ---------------- */
const favKey = (creds) => `${NS}:fav:${userKey(creds)}`;

export const favId = (kind, item) =>
  kind === "series" ? String(item.series_id) : String(item.stream_id);

export const getFavorites = (creds) => read(favKey(creds), []);

export const isFavorite = (creds, kind, item) => {
  const id = favId(kind, item);
  return getFavorites(creds).some((f) => f.kind === kind && String(f.id) === id);
};

export const toggleFavorite = (creds, kind, item) => {
  const id = favId(kind, item);
  const list = getFavorites(creds);
  const exists = list.some((f) => f.kind === kind && String(f.id) === id);
  let next;
  if (exists) {
    next = list.filter((f) => !(f.kind === kind && String(f.id) === id));
  } else {
    next = [{ kind, id, item, addedAt: Date.now() }, ...list];
  }
  write(favKey(creds), next);
  return !exists;
};

/* ---------------- Continue watching ---------------- */
const progKey = (creds) => `${NS}:prog:${userKey(creds)}`;

export const playKeyOf = (record) => `${record.kind}:${record.playableId}`;

export const getProgressList = (creds) => {
  const map = read(progKey(creds), {});
  return Object.values(map).sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
};

export const getProgressFor = (creds, kind, playableId) => {
  const map = read(progKey(creds), {});
  return map[`${kind}:${playableId}`] || null;
};

export const saveProgress = (creds, record) => {
  const map = read(progKey(creds), {});
  const key = playKeyOf(record);
  // Drop finished items (>=93% watched)
  if (record.duration && record.position / record.duration >= 0.93) {
    delete map[key];
  } else {
    map[key] = { ...(map[key] || {}), ...record, updatedAt: Date.now() };
  }
  write(progKey(creds), map);
};

export const clearProgress = (creds, kind, playableId) => {
  const map = read(progKey(creds), {});
  delete map[`${kind}:${playableId}`];
  write(progKey(creds), map);
};

/* ---------------- Last used server ---------------- */
export const getLastServer = () => {
  try {
    return localStorage.getItem(`${NS}:lastserver`) || "";
  } catch {
    return "";
  }
};
export const setLastServer = (server) => {
  try {
    localStorage.setItem(`${NS}:lastserver`, server || "");
  } catch {
    /* ignore */
  }
};

/* ---------------- Search history ---------------- */
const searchKey = (creds) => `${NS}:search:${userKey(creds)}`;

export const getSearchHistory = (creds) => read(searchKey(creds), []);

export const addSearchHistory = (creds, term) => {
  const t = (term || "").trim();
  if (!t) return;
  const list = getSearchHistory(creds).filter((x) => x.toLowerCase() !== t.toLowerCase());
  list.unshift(t);
  write(searchKey(creds), list.slice(0, 12));
};

export const removeSearchHistory = (creds, term) => {
  write(searchKey(creds), getSearchHistory(creds).filter((x) => x !== term));
};

export const clearSearchHistory = (creds) => write(searchKey(creds), []);
